import { Caption, Flex, propTypes, View } from '@tabeo/scarf'
import PropTypes from 'prop-types'
import React from 'react'
import { Link, matchPath, useLocation, useMatch } from 'react-router'

function NavItem({ children, icon, to, href, activePaths, ...rest }) {
  const { pathname } = useLocation()
  // useMatch is exact; append /* to keep v5 useRouteMatch(to)'s prefix matching
  // so a nav item stays active on nested routes. The hook must run
  // unconditionally, so fall back to a sentinel pattern when `to` is absent.
  const match = useMatch(to ? `${to}/*` : '/__no_match__')
  const isActive =
    !!to &&
    (!!match ||
      !!activePaths?.some(path => matchPath({ path, end: false }, pathname)))
  return (
    <Flex
      role="group"
      justifyContent="flex-start"
      px={4}
      py={2}
      position="relative"
      bg={isActive && 'sky.3'}
      _hover={{
        bg: 'sky.2',
      }}
      _active={{
        bg: 'sky.2',
      }}
      cursor="pointer"
      as={(to && Link) || (href && 'a') || undefined}
      to={to || undefined}
      href={href}
      {...rest}
    >
      {isActive && (
        <View
          position="absolute"
          left="0"
          width="3px"
          height="100%"
          bg="primary.3"
        />
      )}
      {icon && (
        <View
          as={icon}
          mr={2}
          width={['24px', '20px']}
          height={['24px', '20px']}
          color={isActive ? 'primary.3' : 'ink.2'}
          _groupHover={{
            color: isActive ? 'primary.3' : 'ink.0',
          }}
        />
      )}
      <Caption
        color={isActive ? 'primary.3' : 'ink.0'}
        fontWeight={isActive ? 'semibold' : 'regular'}
        fontSize={['16px', '14px']}
      >
        {children}
      </Caption>
    </Flex>
  )
}
NavItem.propTypes = {
  children: propTypes.children,
  to: PropTypes.string,
  // A URL outside the router (e.g. a static page of this app); `to` wins.
  href: PropTypes.string,
  // Other routes (and their nested routes) that belong to this item.
  activePaths: PropTypes.arrayOf(PropTypes.string),
  icon: PropTypes.object,
}

export default NavItem
